export class RadiusOfOperation {
    /*
     * Minimum radius of operation in meters (inclusive).
     */
    public static minimum: number = 0.1;

    /*
     * Maximum radius of operation in meters (inclusive).
     */
    public static maximum: number = 257.5;
}
